import { useMultiStyleConfig } from '../../../../../utils/use-style-config';
import { GridItem } from '../../../../internal';
import { Typography } from '../../../typography';
import { jsx as _jsx } from "react/jsx-runtime";
export var Description = _ref => {
  var {
    variant,
    statusIcon,
    label
  } = _ref;
  var styles = useMultiStyleConfig('TrackerStep', {
    variant
  });
  var description = typeof label === 'string' ? /*#__PURE__*/_jsx(Typography.Description, {
    label: label
  }) : label;
  return /*#__PURE__*/_jsx(GridItem, {
    __css: styles['description'],
    children: statusIcon !== null && statusIcon !== void 0 ? statusIcon : description
  });
};
Description.displayName = 'TrackerStep.Description';
//# sourceMappingURL=Description.js.map